import * as React from 'react';
import * as Icons from 'lucide-react';
import { HelpCircle, type LucideIcon } from 'lucide-react';

// Resolve a lucide icon name (kebab-case per the design files, e.g. "trending-up")
// to its PascalCase exported component. Mirrors the resolver in EmptyState so the
// shared atoms can take icon-NAME strings like the portal prototype (common.jsx).
export function resolveIcon(name: string): LucideIcon {
  const pascal = name.replace(/(^|[-_\s])(\w)/g, (_m, _sep, ch: string) => ch.toUpperCase());
  const reg = Icons as unknown as Record<string, LucideIcon>;
  return reg[pascal] ?? reg[name] ?? HelpCircle;
}

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
  className?: string;
}

export function Icon({ name, size = 16, color = 'currentColor', strokeWidth = 2, style, className }: IconProps) {
  const Cmp = resolveIcon(name);
  return <Cmp size={size} color={color} strokeWidth={strokeWidth} style={style} className={className} />;
}

export default Icon;
